import React from 'react'
import styled from 'styled-components'
import { Link } from "gatsby"

// Import Page Level Components

const PGComponentLogin = styled.div`
.es-pg-login {
  // 🎛
  height: 100vh;
  // 🎨
  // 🖋
  font-family: 'Open Sans';
  // 📰
  display: grid;
  grid-template-rows: 0.5fr 1fr;
  grid-template-columns: 1fr;
  grid-template-areas:
    "bin_1"
    "bin_2";

  .es-bin-1 {
    grid-area: bin_1; // 🗺
    background: url("https://res.cloudinary.com/dj1xukpnf/image/upload/v1550263010/login-bg.png") top center no-repeat;
    background-size: cover;
    color: #fff;
    .panel-1 {
      padding: 100px 90px;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      h5 {
        font-size: 18px;
        font-weight: 400;
      }
      ul li {
        font-size: 20px;
      }
    }
  }
  .es-bin-2 {
    grid-area: bin_2; // 🗺
    background-color: white;
    padding: 100px 80px;
    h5{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 18px;
    font-weight: 400;
    color: #2b363b;
    }
  }
}

// Define Responsive Layout Grid - Desktop Spec 🛠
@media only screen and (min-width: 768px) {
  .es-pg-login {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "bin_1 bin_2";
  }
}


.es-bin-1 svg {
height: 40px;
}
.es-c-btn.btn-login {
  font-family: 'Open Sans';
  background-color: #26c1fb;
  border: 0.1rem solid #26c1fb;
  border-radius: 2px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 0.875rem;
  font-weight: 700;
  height: 2.525rem;
  letter-spacing: 0.1rem;
  padding: 0 .6rem;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
  transition: 0.6s cubic-bezier(0.2, 0.8, 0.2, 1);
    &:focus,
    &:hover {
      opacity: 0.9;
      color: #fff;
      outline: 0;
      background-color: #26c1fb; 
      border-color: #26c1fb; 
  }
}
.es-c-btn.btn-forgot-password {
  -webkit-font-smoothing: antialiased;
  text-decoration: underline;
  color: #a9adaf;
  font-size: 14px !important;
  line-height: 1.4;
  letter-spacing: 0;
  padding: 10px 0;
  background: transparent;
  border: transparent;
  transition: 0.6s cubic-bezier(0.2, 0.8, 0.2, 1);
  &:hover {
    color: #505c61;
  }
}

`;

const PageGridComponentLogin = () => {
  return (
    <PGComponentLogin>
        <div className="es-pg-login">
          <div className="es-bin-1">
            <div className="panel-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 422 70"
              >
                <defs>
                  <style
                    dangerouslySetInnerHTML={{
                      __html:
                        ".cls-1{fill:#36ad34;}.cls-2{isolation:isolate;}.cls-3{fill:#3dae2c;}.cls-4{fill:#ffffff;}.cls-5{clip-path:url(#clip-path);}.cls-6{opacity:0.2;mix-blend-mode:multiply;}.cls-7{fill:#58b851;}.cls-8{fill:#71c169;}.cls-9{fill:#fff;}.cls-10{fill:#eaeaea;}.cls-11{fill:#193a81;}"
                    }}
                  />
                  <clipPath id="clip-path">
                    <rect
                      className="cls-1"
                      x="10.29"
                      y="9.21"
                      width="51.24"
                      height="51.24"
                      rx="6.35"
                      ry="6.35"
                      transform="translate(-14.11 35.6) rotate(-45)"
                    />
                  </clipPath>
                </defs>
                <title>Artboard 65</title>
                <g className="cls-2">
                  <g id="Layer_1" data-name="Layer 1">
                    <path
                      className="cls-3"
                      d="M292.39,29.77c13.72,1,17.12,2.72,17.12,13.35,0,7.66.31,15.21-20.09,15.21-11.46,0-19.19-.23-19.64-14.15a1.27,1.27,0,0,1,1.27-1.3h9.36A1.26,1.26,0,0,1,281.67,44c.29,3.75,2.21,4.16,7.75,4.16,5.81,0,7.73-.37,7.73-4.26s-.68-4-6.49-4.33l-2.72-.19c-11.44-.8-18.11-.74-18.11-14s7.48-14.16,19.59-14.16c10.14,0,18.79.19,18.79,13v.65a1.27,1.27,0,0,1-1.27,1.27h-9.39A1.26,1.26,0,0,1,296.3,25c-.32-3.62-2.36-3.62-6.88-3.62-6.68,0-7.23,1.36-7.23,4,0,3.71,1.79,3.83,5.07,4.08Z"
                    />
                    <path
                      className="cls-3"
                      d="M353.13,58h-9.85A1.26,1.26,0,0,1,342,56.7V41a1.26,1.26,0,0,0-1.26-1.26H327.14A1.26,1.26,0,0,0,325.89,41V56.7A1.26,1.26,0,0,1,324.63,58h-9.85a1.26,1.26,0,0,1-1.26-1.26V12.86a1.26,1.26,0,0,1,1.26-1.26h9.85a1.26,1.26,0,0,1,1.26,1.26V27.78A1.26,1.26,0,0,0,327.14,29h13.62A1.26,1.26,0,0,0,342,27.78V12.86a1.26,1.26,0,0,1,1.26-1.26h9.85a1.26,1.26,0,0,1,1.26,1.26V56.7A1.26,1.26,0,0,1,353.13,58Z"
                    />
                    <path
                      className="cls-3"
                      d="M371.66,58h-9.71a1.32,1.32,0,0,1-1.32-1.32V12.92a1.32,1.32,0,0,1,1.32-1.32h9.71A1.32,1.32,0,0,1,373,12.92V56.64A1.32,1.32,0,0,1,371.66,58Z"
                    />
                    <path
                      className="cls-3"
                      d="M378.92,56.73V12.83a1.23,1.23,0,0,1,1.23-1.23h22.07c11.5,0,15.82,4.88,15.82,17,0,13-2.91,17.49-15.82,17.49h-9.71a1.23,1.23,0,0,0-1.23,1.23v9.4A1.23,1.23,0,0,1,390,58h-9.89A1.23,1.23,0,0,1,378.92,56.73Zm20.83-21.39c4.88-.19,5.56-.74,5.56-6.74,0-4.76-.74-6.24-5.56-6.24h-7.23a1.23,1.23,0,0,0-1.23,1.23V34.1a1.23,1.23,0,0,0,1.23,1.23Z"
                    />
                    <path
                      className="cls-4"
                      d="M121.37,47.74H106.82a5.69,5.69,0,0,1-5.69-5.69V38.77h18.52a1.14,1.14,0,0,0,1.14-1.14V31.37a1.14,1.14,0,0,0-1.14-1.14H101.13V27.51a5.69,5.69,0,0,1,5.69-5.69h14.12a1.14,1.14,0,0,0,1.14-1.14v-7.8a1.14,1.14,0,0,0-1.14-1.14H105.73A16.89,16.89,0,0,0,88.84,28.63v12.3a16.89,16.89,0,0,0,16.89,16.89h15.64a1.14,1.14,0,0,0,1.14-1.14v-7.8A1.14,1.14,0,0,0,121.37,47.74Zm45.51-7.37H156.46a1.13,1.13,0,0,0-1.14,1.07,19.29,19.29,0,0,1-.41,3.48,3.31,3.31,0,0,1-1.41,1.72,6,6,0,0,1-2.36.71,31.28,31.28,0,0,1-3.32.15,13.92,13.92,0,0,1-4.3-.52,4.36,4.36,0,0,1-2.3-1.66,6.11,6.11,0,0,1-.92-2.95q-.15-1.81-.15-4.39V30.79a33.57,33.57,0,0,1,.22-4.15,5.56,5.56,0,0,1,1-2.7,4.2,4.2,0,0,1,2.3-1.44,16.1,16.1,0,0,1,4.18-.43q1.54,0,2.86.12a7.48,7.48,0,0,1,2.3.55,3.54,3.54,0,0,1,1.57,1.32,5.65,5.65,0,0,1,.77,2.43v.64a1.14,1.14,0,0,0,1.14,1.14h10.38A1.14,1.14,0,0,0,168,27.13v-.64a25,25,0,0,0-1.29-8.17,9.32,9.32,0,0,0-3.47-4.55,13.26,13.26,0,0,0-5.81-2,68.55,68.55,0,0,0-8.23-.43,63.35,63.35,0,0,0-9.09.58,16.76,16.76,0,0,0-6.82,2.43,11.53,11.53,0,0,0-4.3,5.28,23.62,23.62,0,0,0-1.47,9.15V40.74q0,6.33,1.63,9.83a11.31,11.31,0,0,0,4.52,5.19,16.4,16.4,0,0,0,6.85,2.06q4,.37,8.69.37,2,0,4,0a23.26,23.26,0,0,0,3.78-.37,19.12,19.12,0,0,0,3.56-1,12.66,12.66,0,0,0,3.32-2,10.45,10.45,0,0,0,2.39-2.8,12.79,12.79,0,0,0,1.29-3.16,16.06,16.06,0,0,0,.49-3.44c0-.77,0-2.66.05-3.9A1.13,1.13,0,0,0,166.88,40.37Zm45.35-28.63h-10a1.14,1.14,0,0,0-1.14,1.14V29.07H185V12.88a1.14,1.14,0,0,0-1.14-1.14h-10a1.14,1.14,0,0,0-1.14,1.14v43.8a1.14,1.14,0,0,0,1.14,1.14h10A1.14,1.14,0,0,0,185,56.68V39.76h16V56.68a1.14,1.14,0,0,0,1.14,1.14h10a1.14,1.14,0,0,0,1.14-1.14V12.88A1.14,1.14,0,0,0,212.23,11.74Zm46.88,7.89a12.26,12.26,0,0,0-4.39-5.13A17.33,17.33,0,0,0,248,12a57.65,57.65,0,0,0-17.2,0A17.4,17.4,0,0,0,224,14.51a12.28,12.28,0,0,0-4.39,5.13A20.2,20.2,0,0,0,218,28.27v13a20.2,20.2,0,0,0,1.57,8.63A12.28,12.28,0,0,0,224,55.05a17.4,17.4,0,0,0,6.76,2.49,57.65,57.65,0,0,0,17.2,0,17.33,17.33,0,0,0,6.75-2.49,12.25,12.25,0,0,0,4.39-5.13,20.21,20.21,0,0,0,1.56-8.63v-13A20.21,20.21,0,0,0,259.11,19.64ZM248,39.94a14.31,14.31,0,0,1-.46,4.09,4.33,4.33,0,0,1-1.47,2.27,5.55,5.55,0,0,1-2.68,1,32.15,32.15,0,0,1-4.05.22,31.37,31.37,0,0,1-4-.22,5.46,5.46,0,0,1-2.64-1A4.3,4.3,0,0,1,231.22,44a15.78,15.78,0,0,1-.52-4.09V29.56a15.39,15.39,0,0,1,.52-4.05,4.3,4.3,0,0,1,1.48-2.24,5.47,5.47,0,0,1,2.64-1,31.48,31.48,0,0,1,4-.22,32.27,32.27,0,0,1,4.05.22,5.57,5.57,0,0,1,2.68,1,4.33,4.33,0,0,1,1.47,2.24,14,14,0,0,1,.46,4.05Z"
                    />
                    <rect
                      className="cls-1"
                      x="10.29"
                      y="9.21"
                      width="51.24"
                      height="51.24"
                      rx="6.35"
                      ry="6.35"
                      transform="translate(-14.11 35.6) rotate(-45)"
                    />
                    <g className="cls-5">
                      <image
                        className="cls-6"
                        width={98}
                        height={98}
                        transform="translate(-13.31 -13.09)"
                        xlinkHref="data:image/png;base64,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"
                      />
                      <rect
                        className="cls-3"
                        x="10.29"
                        y="9.21"
                        width="51.24"
                        height="51.24"
                        rx="6.35"
                        ry="6.35"
                        transform="translate(-14.11 35.6) rotate(-45)"
                      />
                      <circle className="cls-7" cx="36.05" cy="34.83" r="30.01" />
                      <circle className="cls-8" cx="36.05" cy="34.83" r="26.23" />
                    </g>
                    <path
                      className="cls-9"
                      d="M35.91,33.1l-8.82.45a.22.22,0,0,0-.21.22V42.7a.22.22,0,0,0,.19.22l8.85,1.34h0l8.85-1.34A.22.22,0,0,0,45,42.7V33.77a.22.22,0,0,0-.21-.22l-8.82-.45Zm0-13.88L27,21.39a.22.22,0,0,0-.17.22v9.93a.22.22,0,0,0,.24.22L35.93,31h0l8.79.74a.22.22,0,0,0,.24-.22V21.61a.22.22,0,0,0-.17-.22L36,19.22ZM25,33.71,19,34.13a.22.22,0,0,0-.23.22v6.91a.22.22,0,0,0,.19.22l5.94.9a.22.22,0,0,0,.26-.22V33.94A.22.22,0,0,0,25,33.71Zm-.07-11.8L19,23.37a.22.22,0,0,0-.17.22v8.74a.22.22,0,0,0,.23.22L25,31.91a.22.22,0,0,0,.22-.22V22.13A.22.22,0,0,0,24.89,21.91Z"
                    />
                    <path
                      className="cls-10"
                      d="M35.94,33.15h0l-8.84.45a.2.2,0,0,0-.19.2v9a.2.2,0,0,0,.17.2l8.86,1.34h0m0-25H35.9L27,21.44a.2.2,0,0,0-.16.2v10a.2.2,0,0,0,.22.2l8.82-.74h0m-11,2.7-6,.41a.2.2,0,0,0-.21.2v6.95a.2.2,0,0,0,.17.2l6,.9a.2.2,0,0,0,.23-.2V34A.2.2,0,0,0,25,33.76ZM24.92,22l-6,1.46a.2.2,0,0,0-.16.2v8.78a.2.2,0,0,0,.21.2L25,32a.2.2,0,0,0,.2-.2v-9.6A.2.2,0,0,0,24.92,22Z"
                    />
                    <path
                      className="cls-4"
                      d="M18.81,43.51v2.2a.36.36,0,0,0,.27.35l.86.21a.36.36,0,0,0,.34-.1l.64-.64a.36.36,0,0,1,.33-.1l2.6.57a.36.36,0,0,1,.22.15l.86,1.24a.36.36,0,0,0,.21.14l1.75.43a.36.36,0,0,0,.32-.07l.93-.79a.36.36,0,0,1,.31-.08l3.61.8a.36.36,0,0,1,.21.13l1.22,1.55a.36.36,0,0,0,.2.13l2.24.55h0l2.24-.55a.36.36,0,0,0,.2-.13L39.59,48a.36.36,0,0,1,.21-.13L43.4,47a.36.36,0,0,1,.31.08l.93.79A.36.36,0,0,0,45,48l1.75-.43a.36.36,0,0,0,.21-.14l.86-1.24A.36.36,0,0,1,48,46l2.6-.57a.36.36,0,0,1,.33.1l.64.64a.36.36,0,0,0,.34.1l.86-.21a.36.36,0,0,0,.27-.35v-2.2a.36.36,0,0,0-.42-.35L36,46.17h-.13l-16.63-3A.36.36,0,0,0,18.81,43.51Z"
                    />
                    <path
                      className="cls-11"
                      d="M36,46.16a.64.64,0,0,1-.23,0l-16.58-3a.36.36,0,0,0-.43.36v2.2a.36.36,0,0,0,.28.35l.86.21a.36.36,0,0,0,.34-.1l.64-.64a.36.36,0,0,1,.33-.1l2.6.57a.36.36,0,0,1,.22.15l.86,1.24a.36.36,0,0,0,.21.14l1.75.43a.36.36,0,0,0,.32-.07l.93-.79a.36.36,0,0,1,.31-.08l3.61.8a.36.36,0,0,1,.21.13l1.22,1.55a.36.36,0,0,0,.2.13l2.24.55h0Z"
                    />
                    <path
                      className="cls-3"
                      d="M46.49,34v8.22a.22.22,0,0,0,.26.22l5.94-.9a.22.22,0,0,0,.19-.22V34.37a.22.22,0,0,0-.23-.22l-5.94-.41A.22.22,0,0,0,46.49,34Z"
                    />
                    <path
                      className="cls-9"
                      d="M46.5,22.18v9.55a.22.22,0,0,0,.22.22l5.94.64a.22.22,0,0,0,.23-.22V23.63a.22.22,0,0,0-.17-.22L46.78,22A.22.22,0,0,0,46.5,22.18Z"
                    />
                    <path
                      className="cls-9"
                      d="M46.49,33.94V42.2a.2.2,0,0,0,.23.2l6-.9a.2.2,0,0,0,.17-.2V34.35a.2.2,0,0,0-.21-.2l-6-.41A.2.2,0,0,0,46.49,33.94Z"
                    />
                  </g>
                </g>
              </svg>
              <h5>Welcome back to EchoShip, the platform that lets you:</h5>
              <ul>
                <li>Create freight quotes</li>
                <li>Enter loads</li>
                <li>Track active shipments</li>
                <li>And much more</li>
              </ul>
            </div>
          </div>
          <div className="es-bin-2">
            <div className="container">
              <div className="columns col-gapless">
                <div className="column col-10">
                  <h5>Already Have An Account? <br /> Please Login</h5>
                  <div className="form-group es-i-username">
                    <label className="form-label label-lg" for="input-username">Username</label>
                    <input
                      className="form-input input-lg" 
                      type="text" 
                      id="input-username"
                      style={{
                        width: "100%"
                      }}
                      />
                  </div>
                  <div className="form-group es-i-password">
                    <label
                      className="form-label label-lg"
                      htmlFor="input-password"
                    >
                      Password
                    </label>
                    <input
                      className="form-input input-lg"
                      type="password"
                      id="input-password"
                      style={{
                        width: "100%"
                      }}
                    />
                  </div>
                  <button className="es-c-btn btn-forgot-password">
                    Forgot password?
                  </button> <br />
                  <Link to="/quote/GetQuote/">
                    <button className="es-c-btn btn-login float-right">
                      Login
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
    </PGComponentLogin>
  )
}

export default PageGridComponentLogin;
